import '@babel/runtime/helpers/extends';
import 'react';
import '@emotion/react';
import SvgUnsatisfiedSelectedEmojiSecondary from './svgs/UnsatisfiedSelectedEmojiSecondary.js';
import SvgUnsatisfiedSelectedEmoji from './svgs/UnsatisfiedSelectedEmoji.js';
import { useIcon } from '../../shared-components/icon/index.js';

var unsatisfiedSelectedEmoji = (props => useIcon(SvgUnsatisfiedSelectedEmoji, SvgUnsatisfiedSelectedEmojiSecondary, props));

export { unsatisfiedSelectedEmoji as default };
